import { PiVault } from "react-icons/pi";

interface UnauthorizedProps {
    message?: string;
}

export const Unauthorized: React.FC<UnauthorizedProps> = ({ 
    message = "You don't have permission to view this page." 
}) => {
    return (
        <div className=" bg-white flex items-center justify-center h-screen">
            <div className=" text-center px-10 py-20">
                <PiVault className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-gray-900">Access Restricted</h2>
                <p className="mt-2 text-gray-600">{message}</p>
            </div>
        </div>
    );
};
